import {Link} from 'react-router-dom';
import React from 'react';

import {ROLE_ADMIN, ROLE_EDITOR} from '../constants/userConstants';
import config from '../config';
import styled from 'styled-components';

import pdfLogo from '../img/pdf_icon.png';
const PDFLink = styled.a`
  cursor: pointer;
`;
const PreviewImage = styled.img`
  border: 2px solid ${props => props.theme.errorColor};
`;

const _displayDocument = win => {
  if (win.document) {
    return (
      <PDFLink
        href={`${config.apiUrl}/download/document/${win._id}?authToken=${config.getPlainAuthToken()}`}
        target="_blank">
        <img src={pdfLogo} alt={win.document} width={30} />
      </PDFLink>
    );
  }
};
const _displayDocumentDownloadLink = win => {
  if (win.document) {
    return (
      <a href={`${config.apiUrl}/download/document/${win._id}?authToken=${config.getPlainAuthToken()}`} target="_blank">
        {win.qualityReportNumber}
      </a>
    );
  }
  return <span>{win.qualityReportNumber}</span>;
};
const _displayDrawing = win => {
  if (win.drawing && win.drawingThumbnail) {
    return (
      <PDFLink
        href={`${config.apiUrl}/download/drawing/${win._id}?authToken=${config.getPlainAuthToken()}`}
        target="_blank">
        <PreviewImage src={win.drawingThumbnail} alt={win.drawing} width={30} />
      </PDFLink>
    );
  }
};
const _drawingtoolTip = win => {
  if (win.drawing && win.drawingThumbnail) {
    return <img src={win.drawingThumbnail} alt={win.drawing} width={400} />;
  }
  return null;
};
export const _displayMeta = meta => {
  if (meta && meta.value) {
    return <span>{meta.value}</span>;
  }
  return null;
};

const windowTableConfig = (user, windowHeight) => {
  return {
    localStorageId: '@wkoWindowStore:windowListPage',
    maxRows: Math.floor((windowHeight - 240) / 65),
    cols: [
      {
        header: 'lfd. Nr.',
        id: '_id',
        valueKey: '*',
        width: '70px',
        method: window => {
          if (user && (user.role === ROLE_EDITOR || user.role === ROLE_ADMIN)) {
            return <Link to={`/edit/window/${window._id}`}>{window.serialNumber}</Link>;
          }
          return <span>{window.serialNumber}</span>;
        },
      },
      {
        header: 'Konstruktion',
        id: 'winType',
        valueKey: 'winType',
        width: '100px',
        method: _displayMeta,
      },
      {
        header: 'Rahmen Stärke',
        id: 'winClass',
        valueKey: 'winClass',
        width: '80px',
        method: _displayMeta,
      },
      {
        header: 'Schnitt',
        id: 'drawing',
        valueKey: '*',
        tooltipMethod: _drawingtoolTip,
        width: '70px',
        method: _displayDrawing,
      },
      {
        header: 'Typ',
        id: 'variation',
        valueKey: 'variation',
        width: '100px',
        method: _displayMeta,
      },
      {
        header: 'Windlast',
        id: 'windLoad',
        valueKey: 'windLoad',
        width: '100px',
        method: _displayMeta,
      },
      {
        header: 'Schlag regen',
        id: 'drivingRain',
        valueKey: 'drivingRain',
        width: '80px',
        method: _displayMeta,
      },
      {
        header: 'Luft durchlässigkeit',
        id: 'airPermeable',
        valueKey: 'airPermeable',
        width: '100px',
        method: _displayMeta,
      },
      {
        header: 'Uw',
        id: 'thermalInsulation',
        valueKey: 'thermalInsulation',
        width: '55px',
        method: _displayMeta,
      },
      {
        header: 'dB',
        id: 'soundInsulation',
        valueKey: 'soundInsulation',
        width: '55px',
        method: _displayMeta,
      },
      {
        header: 'Bedienkräfte',
        id: 'operateForce',
        valueKey: 'operateForce',
        width: '100px',
        method: _displayMeta,
      },
      {
        header: 'Mechanische Beanspruchung',
        id: 'mechanicalStress',
        valueKey: 'mechanicalStress',
        width: '130px',
        method: _displayMeta,
      },
      {
        header: 'Prüfzeugnis',
        id: 'qualityReportNumber',
        valueKey: '*',
        width: '150px',
        method: _displayDocumentDownloadLink,
      },
      {
        header: 'Glastyp',
        id: 'glassType',
        valueKey: 'glassType',
        width: '150px',
        method: _displayMeta,
      },
      {
        header: 'Ug',
        id: 'uValueGlass',
        valueKey: 'uValueGlass',
        width: '55px',
        method: _displayMeta,
      },
      {
        header: 'Ur',
        id: 'uValueFrame',
        valueKey: 'uValueFrame',
        width: '55px',
        method: _displayMeta,
      },
      {
        header: 'Abst.h. psi',
        id: 'psiValue',
        valueKey: 'psiValue',
        width: '80px',
        method: _displayMeta,
      },
      {
        header: 'Breite',
        id: 'width',
        valueKey: 'width',
        width: '70px',
        method: width => <span>{width}</span>,
      },
      {
        header: 'Höhe',
        id: 'height',
        valueKey: 'height',
        width: '70px',
        method: height => <span>{height}</span>,
      },
      {
        header: 'Gesamtfläche',
        id: 'completeSurface',
        valueKey: 'completeSurface',
        width: '90px',
        method: completeSurface => <span>{completeSurface}</span>,
      },
      {
        header: 'Regenschiene Hersteller',
        id: 'rainRackProd',
        valueKey: 'rainRackProd',
        width: '100px',
        method: _displayMeta,
      },
      {
        header: 'Regenschiene',
        id: 'rainRackType',
        valueKey: 'rainRackType',
        width: '180px',
        method: _displayMeta,
      },
      {
        header: 'Dichtung Hersteller',
        id: 'sealProd',
        valueKey: 'sealProd',
        width: '100px',
        method: _displayMeta,
      },
      {
        header: 'Falz dichtung',
        id: 'foldSeal',
        valueKey: 'foldSeal',
        width: '80px',
        method: _displayMeta,
      },
      {
        header: 'Überschlag dichtung',
        id: 'wingSeal',
        valueKey: 'wingSeal',
        width: '120px',
        method: _displayMeta,
      },
      {
        header: 'Beschlag Hersteller',
        id: 'coatingProd',
        valueKey: 'coatingProd',
        width: '100px',
        method: _displayMeta,
      },
      {
        header: 'Beschlag',
        id: 'coatingType',
        valueKey: 'coatingType',
        width: '200px',
        method: _displayMeta,
      },
    ],
  };
};
export default windowTableConfig;



// WEBPACK FOOTER //
// ./src/components/windowTableConfig.js